import React from 'react';
import { useSelector } from 'react-redux';

import { SONAR_SECTIONS } from '../../constants';
import { getViewForChart, getVisibleEntriesForView } from '../../redux/sonar/sonarSelectors';
import { SONAR_DATA_KEYS } from '../../utils/chart';
import { Panel } from '../../components/layout/layout';
import WithToolbarWrapper from '../with-toolbar-wrapper/WithToolbarWrapper';
import ViewRadioGroup from '../view-radio-group/ViewRadioGroup';
import Treemap from '../../components/charts/echarts/Treemap';

const { INTEREST } = SONAR_SECTIONS;
const CHART_INDEX = 0;

function Interest() {
  const view = useSelector(getViewForChart(INTEREST, CHART_INDEX));

  const domainEntries = useSelector(getVisibleEntriesForView(view)) || [];

  return (
    <Panel>
      <WithToolbarWrapper>
        <ViewRadioGroup chartIndex={CHART_INDEX} section={INTEREST} />

        <Treemap data={domainEntries} dataKey={SONAR_DATA_KEYS.INTEREST} showLegend={false} fullWidth isTrend />
      </WithToolbarWrapper>
    </Panel>
  );
}

export default Interest;
